export const GA_MEASUREMENT_ID = "G-0Z1YTRPQ4K";
export const ANALYTICS_CONSENT_KEY = "guardian-analytics-consent-v1";

let loadPromise;

const isBrowser = () => typeof window !== "undefined";

export const getAnalyticsConsent = () => {
  if (!isBrowser()) return null;
  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
};

export const setAnalyticsConsent = (value) => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch {
    // Il consenso resta valido per la sessione anche se lo storage è bloccato.
  }
  window.dispatchEvent(
    new CustomEvent("guardian-analytics-consent-change", { detail: value }),
  );
};

export const loadGoogleAnalytics = () => {
  if (!isBrowser() || getAnalyticsConsent() !== "granted") {
    return Promise.resolve(false);
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!window.__guardianGoogleAnalyticsConfigured) {
    window.__guardianGoogleAnalyticsConfigured = true;
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: false,
      cookie_domain: "auto",
      cookie_flags: "SameSite=Lax;Secure",
    });
  }

  const existing = document.getElementById("guardian-google-analytics");
  if (existing) return Promise.resolve(true);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.id = "guardian-google-analytics";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.addEventListener("load", () => resolve(true), { once: true });
    script.addEventListener("error", () => resolve(false), { once: true });
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const trackGoogleAnalyticsEvent = (event, parameters = {}) => {
  if (!isBrowser() || getAnalyticsConsent() !== "granted") return;
  void loadGoogleAnalytics();
  window.gtag?.("event", event, parameters);
};
